import { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import FleetMap from "@/components/FleetMap";
import { MapPin, AlertTriangle } from "lucide-react";
import logo from "@/assets/boomerang_logo.png";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const STATUS_LABEL = { moving: "En mouvement", idling: "Ralenti", stopped: "À l'arrêt", offline: "Hors ligne" };

export default function SharePage() {
  const { token } = useParams();
  const [unit, setUnit] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await axios.get(`${BACKEND_URL}/api/public/track/${token}`);
      setUnit(r.data);
      setError(null);
    } catch (e) {
      setError(e.response?.status === 410 ? "Ce lien de partage a expiré." : "Lien de partage invalide.");
    }
  }, [token]);

  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [load]);

  const vehicle = unit && unit.last_position ? [{ id: "share", name: unit.name, plate: unit.plate, icon: unit.icon, color: unit.color, status: unit.status, last_position: unit.last_position }] : [];

  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <header className="h-14 glass flex items-center justify-between px-4 z-[1000]">
        <img src={logo} alt="Boomerang" className="h-7 w-auto object-contain" />
        {unit && <span className="text-sm font-semibold flex items-center gap-2" data-testid="share-title"><MapPin className="w-4 h-4 brand-teal" /> {unit.name} · {unit.plate}</span>}
      </header>

      {error ? (
        <div className="flex-1 flex flex-col items-center justify-center gap-3 p-6" data-testid="share-error">
          <AlertTriangle className="w-10 h-10 text-[#F5821F]" />
          <p className="text-muted-foreground">{error}</p>
        </div>
      ) : (
        <div className="relative" style={{ height: "calc(100vh - 3.5rem)" }} data-testid="share-map">
          {vehicle.length > 0 ? (
            <FleetMap vehicles={vehicle} geofences={[]} selected={vehicle[0]} />
          ) : (
            <div className="absolute inset-0 flex items-center justify-center text-muted-foreground">Position indisponible pour le moment…</div>
          )}
          {unit && unit.last_position && (
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 glass rounded-lg px-4 py-2 z-[600] flex items-center gap-4 data text-xs" data-testid="share-info">
              <span className="flex items-center gap-1.5"><span className="w-2 h-2 rounded-full" style={{ background: unit.color }} /> {STATUS_LABEL[unit.status] || unit.status}</span>
              <span>{unit.last_position.speed ?? 0} km/h</span>
              <span className="text-muted-foreground">Suivi en direct · maj 5s</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
